import { FormattedMessage } from 'react-intl'
import RatingStars from '../helpers/RatingStars'
import moment from 'moment'

export default function ScubaTribeRating({ reviews, url }) {
  return (
    <div className='reviews-block scuba-tribe'>
      <div className='review-wrap full-width'>
        {reviews.map((item) => {
          const review = item.fields
          const extraData = review.extra_data
          return (
            <div
              key={item.pk}
              className='review'
            >
              <div className='text-wrap'>
                <div className='star-wrapper'>
                  <span className='rating-elem'>
                    <RatingStars rating={review.rating} />
                  </span>
                  <span className='date'>
                    <FormattedMessage
                      id='reviews_on_date'
                      values={{
                        date: moment(review.date_written).format(
                          'MMMM DD, YYYY'
                        ),
                      }}
                      defaultMessage='Reviewed on {date}'
                    />
                  </span>
                </div>
                <p className='title'>{review.title}</p>
                <p className='review-text'>{review.review.substr(0, 150)}</p>
                <p className='reviewer-name'>
                  <span>
                    <FormattedMessage
                      id='review_by_scubatribe'
                      values={{ username: review.screen_name }}
                      defaultMessage='Review by {username} a ScubaTribe traveler'
                    />
                  </span>
                  <a
                    rel='nofollow'
                    target='_blank'
                    href={extraData.resources.url}
                    className='read-more'
                  >
                    <FormattedMessage
                      id='read_full_review'
                      defaultMessage='Read full review'
                    />
                  </a>
                </p>
              </div>
            </div>
          )
        })}
        <a rel='nofollow' target='_blank' href={url} className='btn-outline'>
          <FormattedMessage
            id='see_more_reviews'
            defaultMessage='See more reviews'
          />
        </a>
      </div>
    </div>
  )
}
